import agent from 'superagent';
import * as model from './model';
import ReactGA from 'react-ga4';

// https://portal.liferay.dev/docs/6-2/tutorials/-/knowledge_base/t/json-web-services-invocation-examples
// https://portal.liferay.dev/docs/6-2/tutorials/-/knowledge_base/t/invoking-json-web-services
// https://portal.liferay.dev/docs/6-2/tutorials/-/knowledge_base/t/service-security-layers
// https://portal.liferay.dev/docs/7-0/tutorials/-/knowledge_base/t/portal-configuration-of-json-web-services


export function getToken(email: string, password: string): string {
	const token: string = email + ":" + password;
	const hash = btoa(unescape(encodeURIComponent(token)));
	return "Basic " + hash;
}

export function fetchDocument(url: string, token: string): Promise<string> {
	let promise: Promise<any> = new Promise((resolve, reject) => {
		agent
			.get(process.env.REACT_APP_API + url)
			.set('Accept', 'application/pdf')
			.set('Authorization', token)
			.then((response: any) => {
				const base64 = btoa(unescape(encodeURIComponent(response.text)));
				resolve(`data:image/jpeg;base64,${base64}`);
			})
			.catch((error: any) => {
				reject(error);
			})
	});
	return promise;
}

export function loadDocument(user: model.User, uuid: string, groupId: string, docName: string,  token: string): Promise<string> {

	const form: FormData = new FormData();
	form.append("uuid", uuid);
	form.append("groupId", groupId);
	form.append("docName", docName);
	form.append("emailAddress", user.emailAddress);

	let promise: Promise<string> = new Promise((resolve, reject) => {
		agent
			.post(process.env.REACT_APP_API + '/api/jsonws/extranet_userhelper.userhelper/load-document')
			.set('Accept', 'application/json')
			.set('Authorization', token)
			.send(form)
			.then((response: any) => {
				const data: string = JSON.parse(response.text);
				resolve(data);
			})
			.catch((error: any) => {
				reject(error);
			});

	});
	return promise;
}

export function getCurrentUser(userEmail: string, userPassword: string): Promise<model.GetUserResponse> {

	const token: string = getToken(userEmail, userPassword);
	let promise: Promise<model.GetUserResponse> = new Promise((resolve, reject) => {
		agent
			.get(process.env.REACT_APP_API + '/api/jsonws/user/get-current-user')
			.set('Accept', 'application/json')
			.set('Authorization', token)
			.then((response: any) => {
				if (response.ok) {
					const user: model.User = JSON.parse(response.text)
					if (user) {
						resolve({
							user: user,
							token: token
						});
					}
				} else {
					reject(response.statusCode);
				}
			})
			.catch((error: any) => {
				reject(error);
			});

	});
	return promise;
}

// curl https://communication.zylk.net/api/jsonws/user/get-user-by-email-address \
//  -u test@liferay.com:test \
//  -d companyId=20115 \
//  -d emailAddress='mikel.asla@zylk.net'
export function touch(user: model.User, token: string): Promise<boolean> {
	const companyId: string = process.env.REACT_APP_COMPANY_ID || "";
	const form: FormData = new FormData();
	form.append("companyId", companyId);
	form.append("emailAddress", user.emailAddress);

	let promise: Promise<boolean> = new Promise((resolve, reject) => {
		agent
			.post(process.env.REACT_APP_API + '/api/jsonws/user/get-user-by-email-address')
			.set('Accept', 'application/json')
			.set('Authorization', token)
			.send(form)
			.then((response: any) => {
				if (response.ok) {
					resolve(true);
				} else {
					reject(response.status)
				}
			})
			.catch(error => {
				reject(error);
			})
	});
	return promise;
}

export function checkUserAgreement(user: model.User, token: string): Promise<boolean> {

	const companyId: string = process.env.REACT_APP_COMPANY_ID || "";
	const form: FormData = new FormData();
	form.append("companyId", companyId);
	form.append("className", "com.liferay.portal.kernel.model.User");
	form.append("tableName", "CUSTOM_FIELDS");
	form.append("columnName", "user_agreement_accepted");
	form.append("classPK", user.userId ? user.userId : "");

	let promise: Promise<boolean> = new Promise((resolve, reject) => {
		agent
			.post(process.env.REACT_APP_API + '/api/jsonws/expandovalue/get-json-data')
			.set('Accept', 'application/json')
			.set('Authorization', token)
			.send(form)
			.then((response: any) => {
				if (response.ok) {
					const json: model.UserAgreementDataResponse = JSON.parse(response.text);
					const value: boolean = json && json.data === "true" ? true : false;
					resolve(value);
				} else {
					reject(response.status)
				}
			})
			.catch(error => {
				reject(error);
			})
	});
	return promise;
}

export function updateUserAgreementState(user: model.User, accepted: boolean, token: string): Promise<boolean> {

	const companyId: string = process.env.REACT_APP_COMPANY_ID || "";
	const data: model.UserAgreementDataRequest = {
		user_agreement_accepted: accepted
	}
	const form: FormData = new FormData();
	form.append("companyId", companyId);
	form.append("className", "com.liferay.portal.kernel.model.User");
	form.append("tableName", "CUSTOM_FIELDS");
	form.append("classPK", user.userId ? user.userId : "");
	form.append("attributeValues", JSON.stringify(data));

	let promise: Promise<boolean> = new Promise((resolve, reject) => {
		agent
			.post(process.env.REACT_APP_API + '/api/jsonws/expandovalue/add-values')
			.set('Accept', 'application/json')
			.set('Authorization', token)
			.send(form)
			.then((response: any) => {
				if (response.ok) {
					resolve(true);
				} else {
					reject(response.status)
				}
			})
			.catch(error => {
				reject(error);
			})
	});
	return promise;
}


export function updateUserFcmtokens(user: model.User, fcmtoken: string, token: string): Promise<void> {

	const companyId: string = process.env.REACT_APP_COMPANY_ID || "";
	const form: FormData = new FormData();
	form.append("companyId", companyId);
	form.append("userId", user.userId ? user.userId : "");
	form.append("fcmtoken", fcmtoken);

	let promise: Promise<void> = new Promise((resolve, reject) => {
		agent
			.post(process.env.REACT_APP_API + '/api/jsonws/extranet_userhelper.userhelper/update-user-fcmtokens')
			.set('Accept', 'application/json')
			.set('Authorization', token)
			.send(form)
			.then((response: any) => {
				if (response.ok) {
					resolve();
				} else {
					reject(response.status)
				}
			})
			.catch(error => {
				reject(error);
			})
	});

	return promise;
}

export function cleanUserFcmtokens(user: model.User, token: string): Promise<void> {

	const companyId: string = process.env.REACT_APP_COMPANY_ID || "";
	const form: FormData = new FormData();
	form.append("companyId", companyId);
	form.append("userId", user.userId ? user.userId : "");

	let promise: Promise<void> = new Promise((resolve, reject) => {
		agent
			.post(process.env.REACT_APP_API + '/api/jsonws/extranet_userhelper.userhelper/clean-user-fcmtokens')
			.set('Accept', 'application/json')
			.set('Authorization', token)
			.send(form)
			.then((response: any) => {
				if (response.ok) {
					resolve();
				} else {
					reject(response.status)
				}
			})
			.catch(error => {
				reject(error);
			})
	});

	return promise;
}


export function updateUserPassword(user: model.User, newValue: string, confirmNewValue: string, token: string): Promise<model.User> {

	const form: FormData = new FormData();
	form.append("userId", user.userId ? user.userId : "");
	form.append("password1", newValue);
	form.append("password2", confirmNewValue);
	form.append("passwordReset", "false");
	let promise: Promise<model.User> = new Promise((resolve, reject) => {
		agent
			.post(process.env.REACT_APP_API + '/api/jsonws/user/update-password')
			.set('Accept', 'application/json')
			.set('Authorization', token)
			.send(form)
			.then((response: any) => {
				if (response.ok) {
					const json: model.User = JSON.parse(response.text);
					resolve(json);
				} else {
					reject(response.status)
				}
			})
			.catch(error => {
				reject(error);
			})
	});
	return promise;
}

function getArticles(folderId: string, languageId: string, token: string): Promise<model.LiferayArticle[]> {

    const groupId: string = process.env.REACT_APP_GROUP_ID || "";

    const params = new URLSearchParams();
    params.append("groupId", groupId);
    params.append("folderId", folderId);
    params.append("locale", languageId.replace('-', '_'));

    let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
        agent
            .get(process.env.REACT_APP_API + '/api/jsonws/journal.journalarticle/get-articles?' + params.toString())
            .set('Accept', 'application/json')
            .set('Authorization', token)
            .then((response: any) => {
                if (response.ok) {
                    const data: model.LiferayArticle[] = JSON.parse(response.text);
                    resolve(data);
                } else {
                    reject(response.statusCode);
                }
            })
            .catch(error => {
                reject(error);
            });
    });
    return promise;
}

// curl http://localhost:6300/api/jsonws/journal.journalarticle/get-article \
// >   -u test@liferay.com:test \
// >   -d groupId=20142 \
// >   -d articleId='34356'
function getArticle(articleId: string, languageId: string, token: string): Promise<model.LiferayArticle> {

	const groupId: string = process.env.REACT_APP_GROUP_ID || "";
	const form: FormData = new FormData();
	form.append("groupId", groupId);
	form.append("articleId", articleId);
	form.append("locale", languageId.replace('-', '_'));

	let promise: Promise<model.LiferayArticle> = new Promise((resolve, reject) => {
		agent
			.post(process.env.REACT_APP_API + '/api/jsonws/journal.journalarticle/get-article')
			.set('Accept', 'application/json')
			.set('Authorization', token)
			.send(form)
			.then((response: any) => {
				if (response.ok) {
					const data: model.LiferayArticle = JSON.parse(response.text)
					resolve(data);
				} else {
					reject(response.statusCode);
				}
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function getOronaNews(token: string, languageId: string): Promise<model.LiferayArticle[]> {
	const folderId: string = process.env.REACT_APP_NEWS_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
		getArticles(folderId, languageId, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function getOronaNew(articleId: string, languageId: string, token: string): Promise<model.LiferayArticle> {
	let promise: Promise<model.LiferayArticle> = new Promise((resolve, reject) => {
		getArticle(articleId, languageId, token)
			.then((article: model.LiferayArticle) => {
				resolve(article);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function getmyOronaNormatives(language: string, token: string): Promise<model.LiferayArticle[]> {
	const folderId: string = process.env.REACT_APP_NORMATIVES_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function getmyOronaVideos(language: string, token: string): Promise<model.LiferayArticle[]> {
	const folderId: string = process.env.REACT_APP_MYORONA_VIDEOS_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function getmyOronaImages(language: string, token: string): Promise<model.LiferayArticle[]> {
	const folderId: string = process.env.REACT_APP_MYORONA_IMAGES_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles);
			})
			.catch(error => {
				reject(error);
			})
	});
	return promise;
}

export function getDimensionImages(language: string, token: string): Promise<model.LiferayArticle[]> {
	const folderId: string = process.env.REACT_APP_DIMENSION_IMAGES_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

// only returning most actualized content of a potential array comming from liferay
export function getDimensionContent(language: string, token: string): Promise<model.LiferayArticle> {
	const folderId: string = process.env.REACT_APP_DIMENSION_CONTENT_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles[0]);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

// only returning most actualized content of a potential array comming from liferay
export function getBrandHeading(language: string, token: string): Promise<model.LiferayArticle> {
	const folderId: string = process.env.REACT_APP_BRAND_HEADING_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles[0]);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function getBrandContent(language: string, token: string): Promise<model.LiferayArticle[]> {
	const folderId: string = process.env.REACT_APP_BRAND_CONTENT_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function getSocial(language: string, token: string): Promise<model.LiferayArticle[]> {
	const folderId: string = process.env.REACT_APP_SOCIAL_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function getPresentations(language: string, token: string): Promise<model.LiferayArticle[]> {
	const folderId: string = process.env.REACT_APP_PRESENTATIONS_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function getReports(language: string, token: string): Promise<model.LiferayArticle[]> {
	const folderId: string = process.env.REACT_APP_MANUALS_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function getOrganizationCharts(language: string, token: string): Promise<model.LiferayArticle[]> {
	const folderId: string = process.env.REACT_APP_ORGANIZATION_CHARTS_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function getOrganizationDocuments(language: string, token: string): Promise<model.LiferayArticle[]> {
	const folderId: string = process.env.REACT_APP_ORGANIZATION_DOCUMENTS_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

// only returning most actualized content of a potential array comming from liferay
export function getLegalInfo(language: string, token: string): Promise<model.LiferayArticle> {
	const folderId: string = process.env.REACT_APP_LEGAL_INFO_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles[0]);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

// only returning most actualized content of a potential array comming from liferay
export function getCookiesInfo(language: string, token: string): Promise<model.LiferayArticle> {
	const folderId: string = process.env.REACT_APP_COOKIES_INFO_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles[0]);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

// only returning most actualized content of a potential array comming from liferay
export function getUserAgreement(language: string, token: string): Promise<model.LiferayArticle> {
	const folderId: string = process.env.REACT_APP_USER_AGREEMENT_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles[0]);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function getBoardDocuments(language: string, token: string): Promise<model.LiferayArticle[]> {
	const folderId: string = process.env.REACT_APP_BOARD_DOCUMENTS_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function getDocumentDetail(articleId: string, language: string, token: string): Promise<model.LiferayArticle> {
	let promise: Promise<model.LiferayArticle> = new Promise((resolve, reject) => {
		getArticle(articleId, language, token)
			.then((article: model.LiferayArticle) => {
				resolve(article);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function getOronaMoveDocuments(language: string, token: string): Promise<model.LiferayArticle[]> {
	const folderId: string = process.env.REACT_APP_ORONAMOVE_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

// width stuff
export function isMobile(width: number): boolean {
	const MOBILE_MAX_WIDTH: number = 991;
	return width <= MOBILE_MAX_WIDTH
}

export function isDesktop(width: number): boolean {
	const DESKTOP_MIN_WIDTH: number = 992;
	return width > DESKTOP_MIN_WIDTH
}

export function getSymbols(): string {
	return "_.!@$*=-?"
}

export function isNotBlank(s: string): boolean {
	return s && s.length > 0 ? true : false
}

export function checkPassword(password: string): boolean {
	// Liferay 7.0 default
	// passwords.passwordpolicytoolkit.validator.charset.symbols=_.!@$*=-?
	//const passwordPolicyRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[_.!@$*=-?])[a-zA-Z0-9_.!@$*=-?]{8,}$/;
	//return password !== null
	//    && password.match(passwordPolicyRegex) !== null
	// let Liferay decide and catch the error
	return isNotBlank(password);
}

export function getPasswordPolicy(): string[] {
	let messages: string[] = [];
	messages.push(`Criterios mínimos para la nueva contraseña: longitud mínima 8 caracteres, 1 letra mayúscula, 1 letra minúscula, 1 número y un carácter especial {${getSymbols()}}`);
	return messages;
}

export function gaPageView(path: string): void {
	const gaKey = process.env.REACT_APP_GA_KEY;
	if (gaKey && gaKey !== undefined) {
		ReactGA.send({ hitType: "pageview", page: path });
	}
}

export function gaEvent(name: string, category: string, action: string): void {
	const gaKey = process.env.REACT_APP_GA_KEY;
	if (gaKey && gaKey !== undefined) {
		ReactGA.event(name, {
	      	category: category,
	      	action: action
	    });
	}
}

export function getOronaMove2(language: string, token: string): Promise<model.LiferayArticle[]> {
	const folderId: string = process.env.REACT_APP_ORONAMOVE_2_FOLDER_ID || "";
	let promise: Promise<model.LiferayArticle[]> = new Promise((resolve, reject) => {
		getArticles(folderId, language, token)
			.then((articles: model.LiferayArticle[]) => {
				resolve(articles);
			})
			.catch(error => {
				reject(error);
			});
	});
	return promise;
}

export function isUserBilingual(user: model.User, token: string): Promise<boolean> {

	const companyId: string = process.env.REACT_APP_COMPANY_ID || "";
	const form: FormData = new FormData();
	form.append("companyId", companyId);
	form.append("className", "com.liferay.portal.kernel.model.User");
	form.append("tableName", "CUSTOM_FIELDS");
	form.append("columnName", "bilingual");
	form.append("classPK", user.userId ? user.userId : "");

	let promise: Promise<boolean> = new Promise((resolve, reject) => {
		agent
			.post(process.env.REACT_APP_API + '/api/jsonws/expandovalue/get-json-data')
			.set('Accept', 'application/json')
			.set('Authorization', token)
			.send(form)
			.then((response: any) => {
				if (response.ok) {
					const json: model.UserAgreementDataResponse = JSON.parse(response.text);
					const value: boolean = json && json.data === "true" ? true : false;
					resolve(value);
				} else {
					reject(response.status)
				}
			})
			.catch(error => {
				reject(error);
			})
	});
	return promise;
}

export function ajustarStringParaGAEvent(section: string, contentTitle: string, documentTitle: string): string {
	  // Base del string para el evento de GA
	  const baseString = `${section} -  - ${documentTitle}`;
	  const baseLength = baseString.length + 3; // +3 por los dos guiones y el espacio entre ellos

	  // Calculamos el tamaño total permitido para contentTitle
	  const maxContentTitleLength = 90 - baseLength;

	  // Verificamos si necesitamos recortar contentTitle
	  let adjustedContentTitle = contentTitle;
	  if (contentTitle.length > maxContentTitleLength) {
	    adjustedContentTitle = contentTitle.substring(0, maxContentTitleLength);
	  }

	  // Construimos el string final para el evento
	  const finalString = `${section} - ${adjustedContentTitle} - ${documentTitle}`;

	  // Verificar el tamaño final por precaución (opcional)
	  if (finalString.length > 90) {
	    console.error('El string final excede los 90 caracteres:', finalString.length);
	  }

	  return finalString;
	}


export function getUserOrganizationIds(userId: string, token: string): Promise<string[]> {

	let form: FormData = new FormData();
	form.append("userId", userId);

	let promise: Promise<string[]> = new Promise((resolve, reject) => {
		agent
			.post(process.env.REACT_APP_API + '/api/jsonws/organization/get-user-organizations')
			.set('Authorization', token)
			.send(form)
			.then((response: any) => {
				if (response.ok) {
					let organizationIds: string[] = [];
					let organizations: model.Organization[] = JSON.parse(response.text);
					organizations.map((organization: model.Organization) => {
						organizationIds.push(organization.organizationId);
						return null;
					});
					resolve(organizationIds);
				} else {
					reject(response.status)
				}
			})
			.catch(error => {
				reject(error);
			})

	});
	return promise;
}

export function askPermission() {
	  return new Promise(function (resolve, reject) {
	    const permissionResult = Notification.requestPermission(function (result) {
	      resolve(result);
	    });

	    if (permissionResult) {
	      permissionResult.then(resolve, reject);
	    }
	  }).then(function (permissionResult) {
	    if (permissionResult !== 'granted') {
	      throw new Error("We weren't granted permission.");
	    }
	  });
	}


export function updateUserLanguage(user: model.User, languageId: string, token: string): Promise<void> {

	let promise: Promise<void> = new Promise((resolve, reject) => {
		getUserOrganizationIds(user.userId || "0", token)
			.then((organizationIds: string[]) => {
				const form: FormData = new FormData();
				form.append("userId", user.userId ? user.userId : "");
				form.append("companyId", process.env.REACT_APP_COMPANY_ID || "20115");
				form.append("languageId", languageId);

				agent
					.post(process.env.REACT_APP_API + '/api/jsonws/extranet_userhelper.userhelper/update-user-language')
					.set('Accept', 'application/json')
					.set('Authorization', token)
					.send(form)
					.then((response: any) => {
						if (response.ok) {
							resolve();
						} else {
							reject(response.status)
						}
					})
					.catch(error => {
						reject(error);
					})
			});


	});
	return promise;
}

export function isBilingual(user: model.User, token: string): Promise<boolean> {

	const companyId: string = process.env.REACT_APP_COMPANY_ID || "";
	const form: FormData = new FormData();
	form.append("companyId", companyId);
	form.append("userId", user.userId ? user.userId : "");
	form.append("languageId", user.languageId ? user.languageId : "");

	let promise: Promise<boolean> = new Promise((resolve, reject) => {
		agent
			.post(process.env.REACT_APP_API + '/api/jsonws/extranet_userhelper.userhelper/is-bilingual')
			.set('Accept', 'application/json')
			.set('Authorization', token)
			.send(form)
			.then((response: any) => {
				if (response.ok) {
					const json: boolean = JSON.parse(response.text);
					resolve(json);
				} else {
					reject(response.status)
				}
			})
			.catch(error => {
				reject(error);
			})
	});

	return promise;
}

export function checkUserLanguage(user: model.User, token: string): Promise<boolean> {

	const companyId: string = process.env.REACT_APP_COMPANY_ID || "";
	const form: FormData = new FormData();
	form.append("companyId", companyId);
	form.append("userId", user.userId ? user.userId : "");
	form.append("languageId", user.languageId ? user.languageId : "");

	let promise: Promise<boolean> = new Promise((resolve, reject) => {
		agent
			.post(process.env.REACT_APP_API + '/api/jsonws/extranet_userhelper.userhelper/check-user-language')
			.set('Accept', 'application/json')
			.set('Authorization', token)
			.send(form)
			.then((response: any) => {
				if (response.ok) {
					const json: boolean = JSON.parse(response.text);
					resolve(json);
				} else {
					reject(response.status)
				}
			})
			.catch(error => {
				reject(error);
			})
	});

	return promise;
}


export function getUser(token: string): Promise<model.User> {

	let promise: Promise<model.User> = new Promise((resolve, reject) => {
		agent
			.get(process.env.REACT_APP_API + '/api/jsonws/user/get-current-user')
			.set('Accept', 'application/json')
			.set('Authorization', token)
			.then((response: any) => {
				if (response.ok) {
					const user: model.User = JSON.parse(response.text)
					if (user) {
						resolve(user);
					}
				} else {
					reject(response.statusCode);
				}
			})
			.catch((error: any) => {
				reject(error);
			});

	});
	return promise;
}
